import './DataSheet.css';

export default function DataSheet() {
    return (
        <section className="section-divider ds-section">
            <div className="section-wrap ds-wrap">
                <div className="ds-content">
                    <h2 className="ds-title">Need all the details offline?</h2>
                    <p className="ds-sub">
                        Download the comprehensive VERDICT Platform Data Sheet. Includes full feature matrices, security compliance details, and ATS integration capabilities.
                    </p>
                </div>
                <div className="ds-action">
                    <a href="./verdict-datasheet.pdf" download="Verdict_DataSheet.pdf" className="btn-outline ds-btn">
                        <span className="ds-icon">📄</span> Download PDF
                    </a>
                </div>
            </div>
        </section>
    );
}